export class IconMap {
    /**
     * Get icon by menu item's title.
     * @param menuTitle - title of menu item
     */
    public static getIcon(menuTitle: string): string | undefined {
        return typeof menuTitle === 'string' ? IconMap.mappings.get(menuTitle.toLowerCase()) : undefined;
    }

    /**
     * Create a map of menu's titles to icons.
     * Menu's titles will be converted to lower case.
     */
    private static getMap(): Map<string, string> {
        const titleToIcons: [string, string][] = [
            ["Client activity", "e942"],
            ["Investments", "e93f"],
            ["Reporting", "e93b"],
            ["Bulk", "e934"],
            ["Tracking", "e939"],
            ["Transactions", "e938"],
            ["Users and access", "e921"],
            ["Product actions", "e93a"],
            ["Charges", "e935"],
            ["Orders", "e93e"],
            ["Workflow", "e936"],
            ["Client details", "e942"],
            ["Transaction history", "e93c"],
            ["Payments", "e93d"],
            ["Money out", "e941"],
            ["Manage portfolio service", "e940"],
            ["Drawdown", "e941"],
            ["Trading", "e93c"],
            ["Tools", "e93d"],
            ["Others", "e91b"],
            ["Transation history", "e93c"],

            // Icons for "Admin" page
            ["Cash", "e934"],
            ["Platform set-up", "e921"],
            ["Bits n bobs", "e938"],
            ["Transfers", "e939"],
            ["Authorisations & Corrections", "e942"],
            ["MI & Reports", "e938"],
            ["Configuration", "e939"],
        ];

        // Convert the title to lower case to make the function more robust,
        // It will not break when the title changes letter case style in the future.
        const map = new Map<string, string>(titleToIcons.map(([title, icon]) => [title.toLowerCase(), icon]));
        return map;
    }

    // Cache the mapping object to improve performance
    private static mappings: Map<string, string> = IconMap.getMap();
}
